var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bizcomp-query-lpwd bizcomp ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),_c('change-pwd',{attrs:{"way":_vm.way}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }